import React, { useEffect, useState } from "react";
import moment from "moment";

const desplegarIcon = require("assets/img/icons/external-icon.png");

// Fecha y hora del reloj corriendo segundo a segundo: la del navegador más la
// diferencia que entregó el servidor. Va aparte para que el tick de cada
// segundo solo repinte esto. Con onClick se muestra como botón
export const RelojVivo = ({ diferenciaMs, esTiempoActual, onClick }) => {
    const [fechaHoraNavegador, setFechaHoraNavegador] = useState(moment());

    useEffect(() => {
        const intervalo = setInterval(
            () => setFechaHoraNavegador(moment()),
            1000,
        );

        return () => clearInterval(intervalo);
    }, []);

    const fechaHoraReloj = moment(fechaHoraNavegador).add(diferenciaMs, "ms");

    let clases = "reloj-desfase__reloj";

    if (!esTiempoActual) clases += " reloj-desfase__reloj--desfase";
    if (onClick) clases += " reloj-desfase__reloj--boton";

    const contenido = (
        <React.Fragment>
            <span className="reloj-desfase__punto" />
            <span className="reloj-desfase__fecha">
                {fechaHoraReloj.format("DD/MM/YYYY")}
            </span>
            <span className="reloj-desfase__hora">
                {fechaHoraReloj.format("HH:mm:ss")}
            </span>
        </React.Fragment>
    );

    if (!onClick) return <div className={clases}>{contenido}</div>;

    return (
        <button
            type="button"
            className={clases}
            title="Cambiar la fecha y hora del reloj"
            onClick={onClick}
        >
            {contenido}
            <img src={desplegarIcon} alt="" className="reloj-desfase__icono" />
        </button>
    );
};
